<div class="container is-min-height is-fullhd">
    <div class="columns">
        <div class="column column-menu is-one-fifth is-hidden-mobile">
            <aside class="menu">
                <p class="menu-label">
                    Benutzer
                </p>
                <ul class="menu-list">
                    <li><a routerLink="/user/data" routerLinkActive="is-active">E-Mail & Benutzer</a></li>
                    <li><a routerLink="/user/password-update" routerLinkActive="is-active">Passwort</a></li>
                </ul>
                <p class="menu-label">
                    Kunde
                </p>
                <ul class="menu-list">
                    <li><a routerLink="/customer/data" routerLinkActive="is-active">Kundendaten</a></li>
                    <li><a routerLink="/customer/favorites" routerLinkActive="is-active">Favoriten</a>
                    </li>
                    <li><a routerLink="/customer/orders" routerLinkActive="is-active">Bestellungen</a></li>
                    <li *ngIf="isAccess('invoices')"><a routerLink="/customer/invoices" routerLinkActive="is-active">Rechnungen</a>
                    </li>
                </ul>
            </aside>
        </div>
        <div class="column">
            <ng-content></ng-content>
        </div>
    </div>
</div>


